import React, {useState} from "react";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import NoSearchResult from "../../../../components/Common/NoSearchResult";
import CardExoTemplate from "./CardExoTemplate";
import {useQuery} from "@tanstack/react-query";
import {ExoService} from "../../../../services/exo.service";
import FeatherIcon from "feather-icons-react";
import usePermissions from "../../../../hooks/usePermissions";
import FormCardExoTemplate from "./FormCardExoTemplate";

interface ModalTemplateProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalExoTemplate: React.FC<ModalTemplateProps> = ({isOpen, onClose}) => {
    const {hasPermission} = usePermissions();

    const [isCreating, setIsCreating] = useState<boolean>(false)
    const [editId, setEditId] = useState<number | null>(null)

    const {data: exoTemplates, isLoading} = useQuery({
        queryKey: ["keyExoTemplates"], queryFn: ExoService.getAllTemplates,
        select: (data) => data.data, refetchOnWindowFocus: false
    });

    const handleCreate = () => {
        setIsCreating(true)
        setEditId(null)
    }

    const handleEdit = (id: number) => {
        setIsCreating(false)
        setEditId(id)
    }

    const handleClose = () => {
        setIsCreating(false)
        setEditId(null)
    }

    const closeModal = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={closeModal}>
            <ModalHeader toggle={closeModal} tag="h4">
                Templates
            </ModalHeader>
            <ModalBody>

                {isLoading ? <div className="my-4"><NoSearchResult text="Loading..."/></div> : (
                    <>
                        {hasPermission('create-echo-templates') && (
                            isCreating ?
                                <FormCardExoTemplate onClose={handleClose}/> : (
                                    <div className="d-flex">
                                        <Button className="d-flex align-items-center gap-2 p-2 mb-3" color="light"
                                                onClick={handleCreate}
                                                disabled={!hasPermission('create-echo-templates')}>
                                            <FeatherIcon icon="plus-circle" size={22} strokeWidth={1.5}/> Create
                                        </Button>
                                    </div>
                                )
                        )}

                        {exoTemplates?.map((template) => {
                            if (editId === template.id)
                                return <FormCardExoTemplate key={template.id}
                                                            templateId={editId} onClose={handleClose}/>

                            return <CardExoTemplate key={template.id} template={template} onEdit={handleEdit}/>
                        })}
                    </>
                )}
            </ModalBody>
        </Modal>
    )
}

export default ModalExoTemplate;